/**
 * Configuration for the seamless chapter scroller.
 */

import { publicPath } from '@utils/public-path';

export interface ScrollerConfig {
  /** Pixels from edge to trigger loading */
  loadThreshold: number;
  /** Number of chapters to keep in DOM (plus/minus from current) */
  keepChapters: number;
  /** Base URL for fetching chapter HTML */
  htmlBasePath: string;
}

export const DEFAULT_CONFIG: ScrollerConfig = {
  loadThreshold: 2000,
  keepChapters: 4,
  htmlBasePath: publicPath('html'),
};
